import { forceUpdate, h, Host } from "@stencil/core";
import { IconLibraryThumbnail } from "./icon-library-thumbnail/icon-library-thumbnail";
import { getIconRegistry } from "../icon/registry";
import { AVAILABLE_ICONS } from "./constants";
export class IconLibrary {
    constructor() {
        this.directSearchLabel = "search";
        this.directSearchPlaceholder = "";
        this.filterLabel = "filter";
        this.categories = [];
        this.assetsPath = undefined;
        this.selectedIcon = undefined;
        this.totalIconNumber = 0;
        this.updateCount = true;
        this.numberOfResults = 0;
        this.iconsList = [];
        this.iconsToShow = [];
        this.filters = {
            directSearch: "",
            weight: [],
            type: [],
            keywords: [],
            categories: []
        };
        this.isLoading = false;
        this.modalIsOpened = false;
        this.code = "";
        this.clickedIcon = "";
        this.legacyNameFiltered = [];
    }
    baseClass = "ux-icon-library";
    inputRef = null;
    connectedCallback() {
        document.addEventListener("uxThemeChange", this.updateAssetsPath);
    }
    disconnectedCallback() {
        document.removeEventListener("uxThemeChange", this.updateAssetsPath);
    }
    componentWillLoad() {
        this.assetsPath = getIconRegistry().assetsPath;
        this.iconsList = AVAILABLE_ICONS[getIconRegistry().theme] || [];
        const categories = [];
        this.iconsList.forEach((icon) => {
            icon.categories?.forEach((category) => {
                if (!categories.includes(category)) {
                    categories.push(category);
                }
            });
        });
        this.categories = categories;
        let counter = 0;
        this.iconsList.forEach((icon) => {
            // @ts-expect-error Check for typing
            counter += icon.outlineWeights.length;
            // @ts-expect-error Check for typing
            counter += icon.filledWeights.length;
        });
        this.totalIconNumber = counter;
    }
    updateAssetsPath = () => {
        this.isLoading = true;
        window.setTimeout(() => {
            this.assetsPath = getIconRegistry().assetsPath;
            this.iconsList = AVAILABLE_ICONS[getIconRegistry().theme] || [];
            let counter = 0;
            this.iconsList.forEach((icon) => {
                // @ts-expect-error Check for typing
                counter += icon.outlineWeights.length;
                // @ts-expect-error Check for typing
                counter += icon.filledWeights.length;
            });
            this.totalIconNumber = counter;
            this.isLoading = false;
            // @ts-expect-error Check for typing
            this.inputRef.setAttribute("value", "");
            forceUpdate(this);
        }, 200);
    };
    updateIconsList() {
        this.iconsToShow = this.iconsList;
    }
    handleDirectSearch = (e) => {
        const eTarget = e.target;
        // @ts-expect-error Check for typing
        const inputValue = eTarget.querySelector("input").value;
        this.filters = {
            ...this.filters,
            directSearch: inputValue.toLowerCase()
        };
    };
    handleWeightChange = (e) => {
        const eTarget = e.target;
        const value = eTarget.value;
        if (!eTarget.checked) {
            this.filters = {
                ...this.filters,
                weight: [...this.filters.weight.filter((size) => size !== value)]
            };
        }
        else {
            this.filters = {
                ...this.filters,
                weight: [...this.filters.weight, value]
            };
        }
    };
    handleTypeChange = (e) => {
        const eTarget = e.target;
        const value = eTarget.value;
        if (!eTarget.checked) {
            this.filters = {
                ...this.filters,
                type: [...this.filters.type.filter((type) => type !== value)]
            };
        }
        else {
            this.filters = {
                ...this.filters,
                type: [...this.filters.type, value]
            };
        }
    };
    handleCategoriesChange = (e) => {
        const eTarget = e.target;
        const value = eTarget.value;
        if (!eTarget.checked) {
            this.filters = {
                ...this.filters,
                categories: [...this.filters.categories.filter((cat) => cat !== value)]
            };
        }
        else {
            this.filters = {
                ...this.filters,
                categories: [...this.filters.categories, value]
            };
        }
    };
    filterIcons() {
        const list = this.iconsList.filter((icon) => {
            // @ts-expect-error Check for typing
            const legacyNames = Object.keys(icon.legacyNames) || [];
            const directSearch = this.filters.directSearch;
            const lowercaseIconName = icon.name.toLowerCase();
            let legacyNamesFilter = false;
            legacyNames.forEach((name) => {
                const lowercaseName = name.toLowerCase();
                if (lowercaseName.includes(directSearch)) {
                    legacyNamesFilter = true;
                }
            });
            if (legacyNamesFilter) {
                // @ts-expect-error Check for typing
                icon["filteredLegacy"] = true;
            }
            else {
                // @ts-expect-error Check for typing
                icon["filteredLegacy"] = false;
            }
            const nameSearch = directSearch === "" || lowercaseIconName.includes(directSearch);
            const keywordSearch = directSearch === "" || icon.keywords?.find((keyword) => keyword.toLowerCase().includes(directSearch));
            const legacyNamesSearch = legacyNamesFilter;
            const weightSearch = this.filters.weight.length === 0 ||
                // @ts-expect-error Check for typing
                this.filters.weight.some((r) => icon.outlineWeights.includes(r)) ||
                // @ts-expect-error Check for typing
                this.filters.weight.some((r) => icon.filledWeights.includes(r));
            const categorySearch = this.filters.categories.length === 0 || this.filters.categories.some((cat) => icon.categories.includes(cat));
            return (nameSearch || keywordSearch || legacyNamesSearch) && weightSearch && categorySearch;
        });
        this.iconsToShow = list;
    }
    onThumbnailDetailClick = (iconThumbnail) => {
        this.modalIsOpened = true;
        this.clickedIcon = iconThumbnail.iconName + iconThumbnail.iconWeight + iconThumbnail.filled;
        this.code = `<ux-icon name="${iconThumbnail.iconName}" weight="${iconThumbnail.iconWeight}"${iconThumbnail.filled ? ` filled` : ``}></ux-icon>`;
    };
    removeFilter = ({ filter, text }) => {
        this.filters = {
            ...this.filters,
            // @ts-expect-error Check for typing
            [filter]: [...this.filters[filter].filter((filter) => filter !== text)]
        };
    };
    onModalClose() {
        this.modalIsOpened = false;
    }
    render() {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        const icons = this.isLoading
            ? []
            : this.iconsToShow.map((icon) => {
                const getThumbnail = (filled) => {
                    return (weight) => {
                        if (this.filters.weight.length !== 0 && !this.filters.weight.includes(weight)) {
                            return null;
                        }
                        if (this.filters.type.length !== 0 && !this.filters.type.includes(filled ? "filled" : "outline")) {
                            return null;
                        }
                        const key = icon.name + weight + filled;
                        // @ts-expect-error Check for typing
                        if (icon["filteredLegacy"]) {
                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                            icon;
                        }
                        return (h(IconLibraryThumbnail, { selected: this.modalIsOpened && key === this.clickedIcon, key: key, iconName: icon.name, iconWeight: weight, filled: filled, iconDescription: icon.description, onDetailsClick: this.onThumbnailDetailClick, assetsPath: this.assetsPath }));
                    };
                };
                // @ts-expect-error Check for typing
                // eslint-disable-next-line @stencil-community/render-returns-host
                return [...icon.outlineWeights.map(getThumbnail(false)), ...icon.filledWeights.map(getThumbnail(true))].filter((item) => item !== null);
            });
        const iconCount = icons.reduce((a, b) => (a || 0) + b.length, 0);
        return (h(Host, { class: this.baseClass }, h("div", { class: `${this.baseClass}__intro-container` }, h("slot", { name: "intro" })), h("div", { class: `${this.baseClass}__search-container` }, h("ux-input-field", { label: this.directSearchLabel, placeholder: this.directSearchPlaceholder, onUxInputChange: this.handleDirectSearch,
            // @ts-expect-error Check for typing
            ref: (el) => (this.inputRef = el), autocomplete: "off" }), h("div", { class: `${this.baseClass}__filter-container` }, h("div", { class: "ux-label" }, this.filterLabel), h("div", { class: `${this.baseClass}__filter` }, h("ux-dropdown", { placeholder: "weight", onChange: this.handleWeightChange }, ["light", "normal", "bold"].map((weight) => (h("ux-checkbox-list-item", { key: weight, label: weight, value: weight, checked: !!this.filters.weight.find((filterWeight) => filterWeight === weight) })))), h("ux-dropdown", { placeholder: "type", onChange: this.handleTypeChange }, ["outline", "filled"].map((type) => (h("ux-checkbox-list-item", { key: type, label: type, value: type })))), h("ux-dropdown", { "search-placeholder": "categories", filterable: true, placeholder: "categories", onChange: this.handleCategoriesChange }, this.categories.map((category) => (h("ux-checkbox-list-item", { label: category, value: category, key: category, checked: !!this.filters.categories.find((filterCategory) => filterCategory === category) }))))))), h("div", { class: `${this.baseClass}__tags-container` }, this.filters.weight.map((weight) => {
            return (h("span", { key: weight, class: "ux-tag", onClick: () => this.removeFilter({
                    filter: "weight",
                    text: weight
                }) }, "WEIGHT: ", weight, h("ux-icon", { name: "cross", weight: "bold" })));
        }), this.filters.type.map((type) => {
            return (h("span", { key: type, class: "ux-tag", onClick: () => this.removeFilter({
                    filter: "type",
                    text: type
                }) }, "TYPE: ", type, h("ux-icon", { name: "cross", weight: "bold" })));
        }), this.filters.categories.map((category) => {
            return (h("span", { key: category, class: "ux-tag", onClick: () => this.removeFilter({
                    filter: "categories",
                    text: category
                }) }, "CATEGORY: ", category, h("ux-icon", { name: "cross", weight: "bold" })));
        }), this.filters.categories.length === 0 && this.filters.type.length === 0 && this.filters.weight.length === 0 && (h("span", null, "No filters applied"))), !this.isLoading && (h("div", { class: `${this.baseClass}__results-details` }, h("span", { class: "ux-u-text-bold" }, iconCount), "/", this.totalIconNumber, " Results")), this.isLoading && (h("div", { class: `${this.baseClass}__loading-container` }, h("div", { class: "ux-horizontal-loader" }))), h("ux-modal", { name: "icon-details-modal", opened: this.modalIsOpened, "sticky-position": "center" }, h("ux-modal-content", null, h("div", { class: "ux-text-title ux-u-margin-bottom-10" }, "Code"), h("ux-code", { language: "html", "copy-button": "Copy", code: this.code })), h("ux-modal-footer", null, h("button", { type: "button", class: "ux-button", onClick: () => (this.modalIsOpened = false) }, "Close"))), !this.isLoading && h("div", { class: `${this.baseClass}__results-container` }, icons)));
    }
    static get is() { return "ux-icon-library"; }
    static get originalStyleUrls() {
        return {
            "$": ["icon-library.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["icon-library.css"]
        };
    }
    static get properties() {
        return {
            "directSearchLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the label of the search input field"
                },
                "attribute": "direct-search-label",
                "reflect": false,
                "defaultValue": "\"search\""
            },
            "directSearchPlaceholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the placeholder of the search input field"
                },
                "attribute": "direct-search-placeholder",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "filterLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the placeholder of the search input field"
                },
                "attribute": "filter-label",
                "reflect": false,
                "defaultValue": "\"filter\""
            }
        };
    }
    static get states() {
        return {
            "categories": {},
            "assetsPath": {},
            "selectedIcon": {},
            "totalIconNumber": {},
            "updateCount": {},
            "numberOfResults": {},
            "iconsList": {},
            "iconsToShow": {},
            "filters": {},
            "isLoading": {},
            "modalIsOpened": {},
            "code": {},
            "clickedIcon": {},
            "legacyNameFiltered": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "iconsList",
                "methodName": "updateIconsList"
            }, {
                "propName": "filters",
                "methodName": "filterIcons"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxModalClose",
                "method": "onModalClose",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=icon-library.js.map
